import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { subscribeNetwork } from '../offline/network';
import { prefetchReferenceData, refreshCodeCounter, syncAll } from '../offline/sync';

// يعمل في الخلفية: ينزّل البيانات المرجعية مع الاتصال، ويرفع الفحوصات المكتملة عند عودته.
export default function SyncManager() {
  const { user } = useAuth();
  const userId = user?.id;
  const auctionId = user?.selected_auction_id;

  useEffect(() => {
    if (!userId) return undefined;

    const runOnline = async () => {
      // العدّاد لكل مستخدم ومزاد، فيُحدَّث في كل مرة؛ البيانات المرجعية مشتركة فتُنزَّل كل فترة.
      await Promise.all([prefetchReferenceData(), refreshCodeCounter()]);
      await syncAll({ onlyCompleted: true });
    };

    runOnline();
    return subscribeNetwork((offline) => {
      if (!offline) runOnline();
    });
  }, [userId, auctionId]);

  return null;
}
